import {
  REMOVE_UNIT,
  INSERT_UNIT,
  LOAD_PROCESSED_UNITS,
  SET_LAST_UNITS_CHECKED,
} from '../actions/unitActions';
import { INSERT_UNIT_CHECKIN_PROFILE } from '../actions/unitCheckinProfileActions';

/**
 * Reducer for adding/processing/removing units
 * @param {object} state
 * @param {object} action
 */
function units(
  state = {
    units: {},
    lastChecked: '',
  },
  action
) {
  switch (action.type) {
    case INSERT_UNIT:
      let unitObj = {};
      if (state.units[action.payload.id]) {
        unitObj = state.units[action.payload.id];
      }
      return {
        ...state,

        units: {
          ...state.units,
          [action.payload.id]: { ...unitObj, ...action.payload },
        },
      };

    case REMOVE_UNIT:
      // get id of incoming unit
      const updatedState = state.units;
      const unitToRemove = action.payload.id;

      // check to see if that id exists, if it does, remove
      delete updatedState[unitToRemove];

      return {
        ...state,

        units: updatedState,
      };

    case SET_LAST_UNITS_CHECKED:
      // Replaces the entire units object in the store with the updated object based on the data returned from the api
      return {
        ...state,
        lastChecked: action.payload,
      };
    case LOAD_PROCESSED_UNITS:
      // Replaces the entire units object in the store with the updated object based on the data returned from the api
      return {
        ...state,
        units: action.payload,
      };
    case INSERT_UNIT_CHECKIN_PROFILE:
      const unit = state.units[action.payload.unit];

      return {
        ...state,
        units: {
          ...state.units,
          [action.payload.unit]: {
            ...unit,
            checkin_profile: action.payload,
            usesCheckin: true,
          },
        },
      };
    default:
      return state;
  }
}

export default units;
